<a
    class="w-full flex flex-col items-center justify-center rounded-lg cursor hover:bg-p-content-hover-background"
    [ngClass]="{
        'bg-p-content-background': menuDrawerStateService.visible(),
        '!bg-primary-50 dark:!bg-primary ': link.isActive && !menuDrawerStateService.visible(),
    }"
    routerLink="/availability/favorites"
    routerLinkActive
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (click)="menuDrawerStateService.close()"
    #link="routerLinkActive"
    pTooltip="Favorites Schedule"
    [tooltipPosition]="viewportService.isMobile() ? 'top' : 'right'">
    @if (menuDrawerStateService.visible() || !link.isActive) {
        <fa-icon class="text-[20px] text-color" [icon]="faStar" />
    } @else {
        <fa-icon class="text-[20px] text-primary dark:text-white" [icon]="faStarSolid" />
    }
</a>
